<script setup lang="ts">
const nuxtApp = useNuxtApp()

const { data: podcasts } = useAsyncData('podcasts-top', () => $fetch('/api/podcasts/'), {
  getCachedData(key) {
    return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
  },
})
</script>

<template>
  <MediaListRow
    :items="podcasts?.data"
    title="Top Podcasts"
    type="podcasts"
    :route="{ name: 'podcasts', query: { query: '' } }"
  />
</template>

<style scoped></style>
